<template>
    <div class="Pesquisa">
        <HeaderLogado></HeaderLogado>
        <BoxPesquisa :termo="termo" :pesquisarFn="eventPesquisar"></BoxPesquisa>

        <div class="conteudo-pesquisa">
            <div class="container pt-4 mb-5">
                <div class="row">
                    <div class="col-12">
                        <span class="txt-p txt-roxo-1 txt-w-bold txt-size-16 c-pointer" @click="voltar"><i class="fas fa-arrow-left"></i> Voltar</span>
                    </div>
                </div>

                <div class="row ">
                    <div class="col-6 mt-4">
                        <span class="txt-p txt-size-16 txt-w-bold txt-cores-1">
                            Resultado da pesquisa
                        </span>
                        
                    </div>
                    <div class="col-6 d-flex flex-column align-items-end">
                        <p class="txt-p txt-cores-6 txt-size-16 mb-1">
                            Termo: "<b>{{termo}}</b>"
                        </p>
                        <p class="txt-p txt-cores-6 txt-size-16">
                            Total de perguntas já respondidas relacionadas a este tema: <b>{{orientacoes.length}}</b>
                        </p>
                    </div>
                </div>
                <div class="row  mb-4" v-if="orientacoes != null && orientacoes.length == 0">
                    <div class="col-12 text-center my-5">
                        <p class="txt-p txt-roxo-1 txt-w-5 txt-size-18">Nenhuma pergunta encontrada!</p>
                    </div>
                </div>
                <div class="row mb-4" v-else>
                    <div class="pesquisa-item mb-4" v-for="(item,index) in orientacoes" :key="index">
                        <div class="p-4">
                            <div class="pesquisa-item-header">
                                <span class="txt-p txt-size-16 txt-w-7 txt-cores-6"> <b class="txt-roxo-2">#{{index+1}}</b> {{item.nmResultado}} </span>
                                <span class="txt-p txt-size-16 txt-cores-1"> <i class="fas fa-calendar txt-roxo-2"></i> Pergunta arquivada em <b>{{item.dtPublicacao}}</b></span>
                            </div>
                            <div class="pesquisa-item-body txt-p txt-size-14 txt-cores-1" v-html="item.dsResultado">

                            </div>
                        </div>
                        <router-link :to="{name:'DetalhePesquisa', params:{id:item.idItemPesquisa}}">
                            <div class="pesquisa-item-visualizar text-center c-pointer">
                                <span class="txt-p txt-white txt-size-14">
                                    <i class="fas fa-eye"></i> Visualizar pergunta
                                </span>
                            </div>
                        </router-link>

                    </div>
                </div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import HeaderLogado from '@/components/HeaderLogado'
    import Footer from '@/components/Footer'
    import BoxPesquisa from '@/components/Pesquisa'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Pesquisa',
        components: { HeaderLogado, Footer, BoxPesquisa },
        props: ['termo'],
        data: function () {
            return {
                busca: null,
                orientacoes: null,
            }
        },
        
        methods: {
            voltar() {
                this.$router.go(-1)
            },

            eventPesquisar(value) {               
                this.busca = value;
                this.load();
            },

            load() {
                let $this = this;                
                axios.get(`${urlApi}/Pergunta/Pesquisa/`, { params: { termo: $this.busca } }, { showLoading: false })
                    .then(res => {                        
                        if (res.data.success) {
                            
                            $this.orientacoes = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtPublicacao = moment(item.dtPublicacao).format('DD/MM/YYYY [às] HH:mm');
                                $this.orientacoes.push(item);
                            }

                            
                        } else {
                            avisoErro("Não foi possível carregar a pesquisa.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

        },
        created: function () {
            this.busca = this.termo;
            this.load();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .conteudo-pesquisa {
        min-height: 46vh;
    }

    .pesquisa-item {
        background: #FFFFFF;
        border: 3px solid #732A90;
        box-sizing: border-box;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        padding: 0;


        .pesquisa-item-header {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #DADADA;
            padding-bottom: 15px;
            margin-bottom: 15px;
        }

        .pesquisa-item-visualizar {
            background: #732A90;
            padding: 10px;
        }
    }
    
    
</style>

